<script setup lang="ts">
import { FontSetting } from "@/models/FontSetting";
import { LoadStatus } from "@/models/frontend-only/LoadStatus";
const DarkModeChordSheetCSS = `
:root{
 color: white;
}
a{
  color: white !important;
}
.cproSSLogo, .song-footer img{
  filter: contrast(0%) saturate(0%) invert(100%) brightness(175%);
}
.cproDirection,
.cproSongKey,
.cproSongLine .chordWrapper .chord {
  color: white ;
}
.cproSongBody {
  background-color: transparent !important;
}
.cproSongKeyChangeWrapper{ 
  color: white !important;
}
`;

let shadowDOM: ShadowRoot | undefined = undefined;
const dark = useDarkModeStore();

const props = defineProps<{
  html?: string;
  fontSize: string;
  fontSettings: {
    headings: FontSetting;
    directions: FontSetting;
    chords: FontSetting;
    lyrics: FontSetting;
  };
}>();

const container = ref<HTMLElement>();
const contentsElement = document.createElement("div");
const status = ref<LoadStatus>();
let mounted = false;
//fetch css and directly inject it instead

onMounted(() => mountShadowDOM());

async function mountShadowDOM() {
  status.value = LoadStatus.Loading;

  if (!container.value) {
    return;
  }
  shadowDOM = container.value.attachShadow({ mode: "open" });
  shadowDOM.appendChild(contentsElement);
  await updateShadowDOM();

  status.value = LoadStatus.Ready;
  mounted = true;
}

const beta = useBetaStore();

const html = computed(() => {
  let rawHtml = props.html || "";

  if (dark.isDarkModeEnabled) {
    rawHtml = rawHtml + "<style>" + DarkModeChordSheetCSS + "</style>";
  }

  rawHtml =
    getCSSForChordSheet(
      props.fontSize,
      props.fontSettings,
      dark.isDarkModeEnabled,
    ) + rawHtml;

  return rawHtml;
});

async function updateShadowDOM() {
  status.value = LoadStatus.Loading;
  contentsElement.innerHTML = html.value;
  status.value = LoadStatus.Ready;
}

const applyFontSize = computed(
  () => (parseInt(props.fontSize) / 16).toFixed(3) + "em",
);
</script>

<template>
  <div id="ChordSheetViewerFontScaler">
    <div
      id="ChordSheetViewerContainer"
      ref="container"
      class="sheet-music-chords"
      :style="{ 'font-size': applyFontSize }"
    >
      <div
        v-if="status !== LoadStatus.Ready"
        class="loading-spinner"
      >
        <FAIcon class="fa-light fa-spinner-third fa-spin fa-3x" />
      </div>
      <div v-if="status === LoadStatus.Ready"></div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.sheet-music-chords {
  @apply p-5 md:p-10;
}
</style>
<style lang="postcss">
.sheet-music-chords {
  @apply overflow-x-auto;
}
#ChordSheetViewerFontScaler {
  font-size: 0.4rem;
  @media (min-width: 475px) {
    font-size: 0.5rem !important;
  }

  @media (min-width: 575.98px) {
    font-size: 0.6rem !important;
  }
  @media (min-width: 767.98px) {
    font-size: 0.8rem !important;
  }
  @media (min-width: 875px) {
    font-size: 0.9rem !important;
  }
  @media (min-width: 1024px) {
    font-size: 0.7rem !important;
  }
  @media (min-width: 1199.98px) {
    font-size: 0.8rem !important;
  }
  @media (min-width: 1399.98px) {
    font-size: 1rem !important;
  }
}
</style>
